import React, { Component } from "react";

import Header1 from "parts/Header1";
import HeroTeam1 from "parts/HeroTeam1";
import AllTeam1 from "parts/AllTeam1";
import Footer1 from "parts/Footer1";

import { TeamMembers } from "json/landingPageData1";

export default class TeamPage1 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header1 />
        <HeroTeam1 />
        <AllTeam1 data={TeamMembers} />
        <Footer1 />
      </>
    );
  }
}
